import { render } from "./AdminPeakfactorCreate.vue?vue&type=template&id=da17faec&scoped=true&ts=true&lang=true"
import script from "./AdminPeakfactorCreate.vue?vue&type=script&lang=ts"
export * from "./AdminPeakfactorCreate.vue?vue&type=script&lang=ts"

import "./AdminPeakfactorCreate.vue?vue&type=style&index=0&id=da17faec&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da17faec"]])

export default __exports__